(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/mode-shift-link.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/mode-shift-link.js');

'use strict';

const Link = svs.app.ReactRouter.Link;
const route = svs.playerLoginReact.constants.route;

const ModeShiftLink = () => {
  const isLogin = ReactRedux.useSelector(state => state.playerloginreact.isLogin);
  const to = isLogin ? route.REGISTRATE_FREJAEID_ROUTE : route.LOGIN_FREJAEID_ROUTE;
  const text = isLogin ? 'Bli kund' : 'Logga in';
  return React.createElement("div", {
    className: "animate animate-show animate-time-short"
  }, React.createElement(Link, {
    className: "cf-navy f-bold u-text-decoration-underline",
    title: "Bli kund",
    to: to
  }, React.createElement("span", {
    className: "fc-navy"
  }, text)));
};
svs.playerLoginReact.sharedComponents.ModeShiftLink = ModeShiftLink;

 })(window);